import { t } from "@lingui/core/macro";

export function getFieldStatusLabel(status: {
  field_status: string;
  field_capacity_learning?: boolean;
}): string {
  return status.field_status === "Undefined" && status.field_capacity_learning
    ? t`Learning`
    : status.field_status;
}
